import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import SEO from "../components/SEO";

const NotFound = () => (
  <>
    <SEO title="Page Not Found | Revival Fire Ministries Global" description="The page you were looking for could not be found." path="/404" noindex />
    <main className="relative min-h-screen flex flex-col" data-testid="not-found">
      <Navbar />
      <section className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-xl text-center">
          <div className="overline mb-4">404</div>
          <h1 className="font-serif-display text-5xl sm:text-6xl text-[#F6F0E6]">This path is <span className="italic gold-text">empty</span></h1>
          <p className="mt-4 text-[#D9D9D9]">The page you were searching for could not be found. The fire is still burning — let&rsquo;s get you back home.</p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="btn-gold !py-3 !px-6 !text-sm"><Home className="h-4 w-4" /> Back to home</Link>
            <Link to="/request-prayer" className="btn-ghost !py-3 !px-6 !text-sm">Request Prayer</Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  </>
);

export default NotFound;
